import React from "react";
import { Ratings, RatingsProps } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";

interface Props extends Omit<RatingsProps, "size" | "rating"> {
  rating: number;
  size?: keyof typeof sizes;
  containerClasses?: string;
}

const sizes = {
  small: "xsmall",
  base: "small",
  large: "medium",
  extraLarge: "large",
} as const;

const Stars = ({
  rating,
  size = "base",
  className,
  containerClasses,
  ...ratingsProps
}: Props) => (
  <>
    {!!rating && rating > 0 ? (
      <Ratings
        rating={rating}
        size={sizes[size]}
        theme="wss"
        data-testid="brand-rating"
        className={cls(
          "inline-flex align-middle mt-px",
          className,
          containerClasses,
        )}
        {...ratingsProps}
      />
    ) : null}
  </>
);

export default Stars;
